/**
 * Views Module
 * Imported in app_* level
 */
import {NgModule, ModuleWithProviders} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ViewsService} from "./views.service";
import {ViewsIfDirective} from "./viewsIf.directive";
import {ViewsShowDirective} from "./viewsShow.directive";
import { ConfigurationResourceModule } from '../service/resources/configuration/configurationResource.module';


@NgModule({
    imports: [
        CommonModule,
        ConfigurationResourceModule,
    ],
    declarations: [
        ViewsIfDirective,
        ViewsShowDirective
    ],
    exports:[
        ViewsIfDirective,
        ViewsShowDirective
    ],
    providers: [
        ViewsService,
    ]
})
export class ViewsModule {
}
